const React = require('react');
const Ripple = require('../Ripple');
const ArrowLeftAIcon = require('../../icons/ArrowLeftA');


module.exports = (props) => {
  return (
    <Ripple
      {...props}
      className={`f16 fw5 tdN olN layoutRow fhaC fvaC cF h52 ph20 ovH usN
        bgF1 bgF2:not[.disabled]:h dn r4 ` + (props.className || '')}
    >
      <ArrowLeftAIcon className="w15"/>
      <div className="pl8">Back</div>
    </Ripple>
  );
};
